import { useGetMany } from "react-admin";
import { employeeRequests } from "api/employeeApi";
import { getDisplayName } from "utils/helpers";

// Returns one name per traveler, in the entered order.
export const useTravelerNames = travelers => {
  const rows = travelers ?? [];
  const employeeIds = rows.map(t => t?.employeeId).filter(Boolean);
  const { data: employees } = useGetMany(employeeRequests.getEmployeesSelect(), { ids: employeeIds });

  return rows.map(traveler => {
    if (traveler?.employeeId) return getDisplayName(employees?.find(e => e.id === traveler.employeeId));
    if (traveler?.fullName) return traveler.fullName;
    // Students saved before the name became required are only identifiable by faculty number.
    return traveler?.facultyNumber ? `№ ${traveler.facultyNumber}` : null;
  });
};
